import styled, { css } from 'styled-components';
import { isGlobetrotter } from '../../../utils/theming.js';

// @ts-nocheck
var Paragraph = styled.p.withConfig({
  displayName: "Paragraphstyle__Paragraph",
  componentId: "sc-1xn344v-0"
})(["white-space:pre-wrap;", ""], isGlobetrotter(css(["color:var(--color-text-subtle);font:var(--font-body-s);"])));

export { Paragraph };
//# sourceMappingURL=Paragraph.style.js.map
